







































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { vxm } from '../../store.vuex';
import { UserProfile } from '../../models/userdata/profile';
import Datepicker from 'vuejs-datepicker';
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import { Location } from '../../models/userdata/Location';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});

@Component({
  name: 'MyProfileDetails',
  components: {
    Datepicker,
    VueGoogleAutocomplete,
  },
})
export default class MultipleLocationDetails extends Vue {
  @Prop({ default: [] }) desiredLocations;

  $refs!: {
    address: any;
  };
  private locations: Location[] = [];

  getAddressData(addressData, placeResultData, id) {
    let locationAlreadyExist = false;
    let selectedLocationObject: Location = new Location();
    selectedLocationObject.locationAddress = placeResultData.formatted_address;
    selectedLocationObject.latitude = addressData.latitude;
    selectedLocationObject.longitude = addressData.longitude;
    selectedLocationObject.city =
      placeResultData.address_components[0].long_name;
    selectedLocationObject.state = addressData.administrative_area_level_1;
    selectedLocationObject.country = addressData.country;
    for (let i = 0; i < this.desiredLocations.length; i++) {
      if (
        this.lodash.isEqual(
          selectedLocationObject.latitude,
          this.desiredLocations[i].latitude,
        ) &&
        this.lodash.isEqual(
          selectedLocationObject.longitude,
          this.desiredLocations[i].longitude,
        )
      ) {
        console.log('Locations are equal');
        locationAlreadyExist = true;
        break;
      }
    }
    if (!locationAlreadyExist)
      this.desiredLocations.push(selectedLocationObject);
    this.$refs.address.$el.value = '';
  }

  locationText(location) {
    const tempArray: any = [];
    location.city && tempArray.push(location.city);
    location.state && tempArray.push(location.state);
    if (!location.city && !location.state && location.country) {
      tempArray.push(location.country);
    }
    return tempArray.join(', ');
  }

  removeLocation(index) {
    this.desiredLocations.splice(index, 1);
  }
}
